/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-08-14 11:08:44
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-08-14 11:20:26
 * @FilePath: \合联\oms\src\api\airManagement\warehousing.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/warehouse/GoodsInbound'

export const apis = buildApi({
  get: [name + '/index&list',name+'/type'],
  post: [name + '/save']
})